<div class="settings">
  <div (click)="isToggle = !isToggle" class="head">
    Settings
    <i class="fa"
       [class.fa-caret-down]="isToggle"
       [class.fa-caret-up]="!isToggle"></i>
  </div>
  <div [collapse]="isToggle">
    <div>
      <span>
        <input [checked]="getIsSet(approvalType.ByPerformanceManager, process.approvalRequirementTypes)" (click)="toggleSetting(approvalType.ByPerformanceManager, process.approvalRequirementTypes)" id="pm-confirmation" type="checkbox">
        <label for="pm-confirmation">PM approval</label>
      </span>
    </div>
      <div>
          <span>
              <input [checked]="getIsSet(approvalType.ByDepartmentAdministrator, process.approvalRequirementTypes)" (click)="toggleSetting(approvalType.ByDepartmentAdministrator, process.approvalRequirementTypes)" id="hr-confirmation" type="checkbox">
              <label for="hr-confirmation">HR approval</label>
          </span>
      </div>
      <div>
          <span>
              <input [checked]="process.isProcessParticipationSkippable" (click)="toggleProcessParticipationSkippable()" id="skippable" type="checkbox">
              <label for="skippable">Can be skipped</label>
          </span>
      </div>
  </div>
</div>



